import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import store from '@/store'

Vue.use(Router)

let router = new Router({
    mode: 'history',
    // base: process.env.BASE_URL,
    routes: [{
            path: "/Login",
            name: "Login",
            component: () =>
                import ('@/views/pages/Login'),
            meta: { requiresAuth: false }

        },
        {
            path: '/',
            redirect: '/dashboard',
            component: () =>
                import ('@/layouts/Layout'),
            meta: { requiresAuth: true },
            children: [
                // Components



                {
                    name: 'Users',
                    path: 'Users',
                    component: () =>
                        import ('@/views/Users/Users'),
                },
                {
                    name: 'User',
                    path: 'User/:id',
                    component: () =>
                        import ('@/views/Users/User'),
                },
                {
                    name: 'Sellers',
                    path: 'Sellers',
                    component: () =>
                        import ('@/views/Sellers/Sellers'),
                },
                {
                    name: 'Seller Verification',
                    path: 'sellerVerification',
                    component: () =>
                        import ('@/views/Sellers/sellerVerification'),
                },
                {
                    name: 'Seller',
                    path: 'Seller/:id',
                    component: () =>
                        import ('@/views/Sellers/Seller'),
                },
                {
                    name: 'SellerEdit',
                    path: 'sellerEdit',
                    component: () =>
                        import ('@/views/Sellers/sellerEdit'),
                },
                {
                    name: 'SellerOffer',
                    path: 'sellerOffer',
                    component: () =>
                        import ('@/views/Sellers/sellerOffer'),
                },
                {
                    name: 'SellerSold',
                    path: 'sellerSold',
                    component: () =>
                        import ('@/views/Sellers/sellerSold'),
                },
                {
                    name: 'offerVerification',
                    path: 'offerVerification',
                    component: () =>
                        import ('@/views/Offer/offerVerification'),
                },
                {
                    name: 'offers',
                    path: 'offers',
                    component: () =>
                        import ('@/views/Offer/offers'),
                },
                {
                    name: 'DiscountVerification',
                    path: 'discountVerification',
                    component: () =>
                        import ('@/views/Discount/discountVerification'),
                },
                {
                    name: 'DiscountProducts',
                    path: 'discountProducts',
                    component: () =>
                        import ('@/views/Discount/discountProducts'),
                },
                {
                    name: 'Purchases',
                    path: 'Purchases',
                    component: () =>
                        import ('@/views/Purchases/purchases'),
                },
                {
                    name: 'Purchase',
                    path: 'Purchase/:id',
                    component: () =>
                        import ('@/views/Purchases/purchase'),
                },
                {
                    name: 'PurchaseList',
                    path: 'purchaseList',
                    component: () =>
                        import ('@/views/Purchases/purchaseList'),
                },
                {
                    path: 'category',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            name: 'category',
                            component: () =>
                                import ('@/views/Category/Categories'),
                        },
                        {
                            name: 'subcategory',
                            path: ':id',
                            props: true,
                            component: () =>
                                import ('@/views/Category/Category'),
                        },
                        {
                            name: 'categorytype',
                            path: 'categoryType/:id',
                            props: true,
                            component: () =>
                                import ('@/views/Category/categoryType'),
                        },
                    ]
                },
                {
                    name: 'subCategorySlider',
                    path: 'subCategorySlider',
                    props: true,
                    component: () =>
                        import ('@/views/addImages/subCategorySlider'),
                },
                {
                    name: 'Products',
                    path: 'Products',
                    component: () =>
                        import ('@/views/Products/products'),
                },
                {
                    name: 'Products Verification',
                    path: 'productVerification',
                    component: () =>
                        import ('@/views/Products/productVerification'),
                },
                {
                    name: 'productDetails',
                    path: 'productDetails/:id',
                    component: () =>
                        import ('@/views/Products/productDetails'),
                },
                {
                    name: 'ProductEdit',
                    path: 'productEdit',
                    component: () =>
                        import ('@/views/Products/productEdit'),
                },
                {
                    name: 'cancelledProducts',
                    path: 'cancelledProducts',
                    component: () =>
                        import ('@/views/Products/cancelledProducts'),
                },
                {
                    name: 'returnedProducts',
                    path: 'returnedProducts',
                    component: () =>
                        import ('@/views/Products/returnedProducts'),
                },
                {
                    name: 'gst',
                    path: 'gst',
                    component: () =>
                        import ('@/views/GST/gst'),
                },

                {
                    path: 'addImage',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: 'category',
                            name: 'categoryImage',
                            component: () =>
                                import ('@/views/addImages/category'),
                        },
                        {
                            name: 'subcategoryImage',
                            path: 'category/:id',
                            props: true,
                            component: () =>
                                import ('@/views/addImages/subcategory'),
                        },
                    ]
                },


                {
                    name: 'Changepassword',
                    path: 'Changepassword',
                    component: () =>
                        import ('@/views/Settings/changePassword'),
                },


                {
                    name: 'Profile',
                    path: 'pages/profile',
                    component: () =>
                        import ('@/views/pages/Profile'),
                },


                {
                    name: 'Dashboard',
                    path: 'dashboard',
                    component: () =>
                        import ('@/views/dashboard/BasicDashboard'),
                },

            ]
        },

    ],
})

router.beforeEach((to, from, next) => {
    if (localStorage.getItem('token')) {
        var newURL = ''
        if (localStorage.getItem('role') == 'employee')
            newURL = "/authenticate/user";

        else
            newURL = "authenticate/admin";
        axios({
                method: "POST",
                url: newURL,
                headers: {
                    "token": localStorage.getItem("token")
                }
            })
            .then(response => {
                if (!response.data.status) {
                    localStorage.removeItem("token");
                    localStorage.removeItem("role");
                    store.commit("logoutUser");
                    next({
                        name: 'Login'
                    })
                    return
                }
            })
    }
    if (to.matched.some(route => route.meta.requiresAuth) && !store.state.isLoggedIn) {
        next({
            name: 'Login'
        })
        return
    }
    if (to.path === '/Login' && store.state.isLoggedIn) {
        next({
            path: '/'
        })
        return
    }
    next()
})

export default router